<div class="input-fields">
  <zaver-dropdown 
    [title]="nonOwner ? 'Typ av huvudman' : 'Typ av ägare'"
    [inputModel]="selectedOwnerType" 
    [selectOptions]="ownerTypeOptions" 
    (inputModelChange)="ownerTypeChange($event)"
    [error]="showError && formGroup.controls.ownerType.invalid"
    [errorMessage]="'Vänligen ange en ägartyp'">
  </zaver-dropdown>
</div>

<app-company-owner-natural 
  *ngIf="selectedOwnerType === 'natural'" 
  [displayingInCompanyAdminPage]="displayingInCompanyAdminPage"
  [formGroup]="formGroup"
  [showError]="showError"
  [nonOwner]="nonOwner">
</app-company-owner-natural>

<div *ngIf="selectedOwnerType === 'legal'">
  <app-company-owner-legal 
    [displayingInCompanyAdminPage]="displayingInCompanyAdminPage"
    [formGroup]="formGroup"
    [showError]="showError"
    [nonOwner]="nonOwner"
    (correctOrganizationNumberEmit)="correctOrganizationNumber = true">
  </app-company-owner-legal>

  <div *ngIf="!nonOwner && correctOrganizationNumber">
    <zaver-dropdown 
      id="dropdown" 
      [title]="'Antalet ägare (fysisk eller juridisk person) med mer än 25% av röst/ägarandelarna'"
      [inputModel]="selectedOwnerNumberOption"
      [error]="showError && formGroup.controls.numOwners.invalid" 
      [errorMessage]="'Vänligen ange antalet ägare'"
      [selectOptions]="ownerNumberOptions" 
      (inputModelChange)="nrOwnerChange($event)">
    </zaver-dropdown>
    <ng-container class="card-accordion-container" *ngFor="let owner of owners.controls; let i = index">
      <hr class="divider"/>
      <div class="owner-header">
        <h3>Ägare {{i + 1}} av {{formGroup.controls.name.value}}: <span class="cerise-text">{{getOwnerName(i)}}</span></h3>
        <div class="owner-heading-close" (click)="removeOwner(i)">
          <svg width="14" height="14" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g [attr.clip-path]="'url(#clip{{i}})'">
              <path d="M0.311048 15.1869C0.111821 15.3862 -6.63714e-05 15.6565 5.19422e-08 15.9383C6.64753e-05 16.2202 0.112081 16.4904 0.311403 16.6896C0.510724 16.8889 0.781024 17.0007 1.06284 17.0007C1.34466 17.0006 1.6149 16.8886 1.81413 16.6893L8.37471 10.1294C8.39116 10.1129 8.41071 10.0998 8.43222 10.0909C8.45373 10.082 8.4768 10.0774 8.50009 10.0774C8.52338 10.0774 8.54645 10.082 8.56796 10.0909C8.58947 10.0998 8.60901 10.1129 8.62546 10.1294L15.186 16.6907C15.2847 16.7894 15.4018 16.8677 15.5307 16.9211C15.6596 16.9745 15.7978 17.0021 15.9373 17.0021C16.0769 17.0021 16.2151 16.9747 16.344 16.9213C16.4729 16.8679 16.5901 16.7897 16.6888 16.691C16.7875 16.5924 16.8658 16.4753 16.9192 16.3464C16.9726 16.2175 17.0001 16.0793 17.0002 15.9398C17.0002 15.8002 16.9728 15.662 16.9194 15.5331C16.866 15.4042 16.7878 15.287 16.6891 15.1883L10.1293 8.62561C10.1128 8.60916 10.0997 8.58962 10.0908 8.56811C10.0818 8.54659 10.0772 8.52353 10.0772 8.50024C10.0772 8.47694 10.0818 8.45388 10.0908 8.43237C10.0997 8.41085 10.1128 8.39131 10.1293 8.37486L16.6905 1.81428C16.8898 1.61477 17.0016 1.34429 17.0014 1.06234C17.0012 0.780391 16.889 0.510068 16.6895 0.310841C16.49 0.111614 16.2195 -0.000198988 15.9375 2.65851e-07C15.6556 0.00019952 15.3853 0.112395 15.186 0.311904L8.62546 6.87107C8.60901 6.88756 8.58947 6.90065 8.56796 6.90957C8.54645 6.9185 8.52338 6.9231 8.50009 6.9231C8.4768 6.9231 8.45373 6.9185 8.43222 6.90957C8.41071 6.90065 8.39116 6.88756 8.37471 6.87107L1.81413 0.311904C1.71548 0.21321 1.59836 0.134912 1.46946 0.0814818C1.34055 0.0280513 1.20238 0.000534001 1.06284 0.000501114C0.781024 0.000434695 0.510724 0.112322 0.311402 0.311549C0.112081 0.510777 6.64487e-05 0.781024 2.95541e-08 1.06284C-6.63896e-05 1.34466 0.111821 1.61496 0.311048 1.81428L6.87092 8.37486C6.88741 8.39131 6.9005 8.41085 6.90943 8.43237C6.91835 8.45388 6.92295 8.47694 6.92295 8.50024C6.92295 8.52353 6.91835 8.54659 6.90943 8.56811C6.9005 8.58962 6.88741 8.60916 6.87092 8.62561L0.311048 15.1869Z" fill="#0A1018"/>
            </g>
            <defs>
              <clipPath id="clip{{i}}">
                <rect width="17" height="17" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <app-signup-company-owner 
        [displayingInCompanyAdminPage]="displayingInCompanyAdminPage"
        [formGroup]="getOwner(i)"
        [showError]="showError">
      </app-signup-company-owner>
    </ng-container>
    
  </div>
</div>
